"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGolfOrderLineChanges = void 0;
const dayjs = require("dayjs");
const pluralize_1 = require("../pluralize");
const getGolfOrderLineChanges = (previous, current) => {
    const changed_items = [];
    const changes = {};
    // Check if date has changed
    if (previous.where_when_who.date !== current.where_when_who.date) {
        changed_items.push("Date of play");
        changes.date = {
            has_changed: true,
            previous_value: dayjs(previous.where_when_who.date).format("ddd, Do MMM YYYY"),
        };
    }
    // has the course combo changed?
    if (previous.course.hole_options !== current.course.hole_options) {
        changed_items.push("Course");
        changes.course = {
            has_changed: true,
            previous_value: previous.course.name?.en,
        };
    }
    // has the product changed?
    if (previous.product.id !== current.product.id) {
        changed_items.push("Product");
        changes.product = {
            has_changed: true,
            previous_value: previous.product.name?.en,
        };
    }
    // has the number of players changed?
    if (previous.where_when_who.number_of_golfers !==
        current.where_when_who.number_of_golfers) {
        changed_items.push("No. of Players");
        changes.players = {
            has_changed: true,
            previous_value: (0, pluralize_1.pluralize)(previous.where_when_who.number_of_golfers, "Player", "Players"),
        };
    }
    return {
        ...changes,
        changes: changed_items,
    };
};
exports.getGolfOrderLineChanges = getGolfOrderLineChanges;
